"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Placement = void 0;
exports["default"] = resolvePositioning;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Placement = exports.Placement = {
  Above: 'above',
  Below: 'below'
};
var TOOLTIP_SPACING = 5;
function resolvePositioning(tooltip, _ref, usePosition, center) {
  var at = _ref.at,
    adjustment = _ref.adjustment;
  var isAbove = usePosition === Placement.Above;
  var isBelow = usePosition === Placement.Below;
  var element = tooltip && tooltip.current;
  var rect = element ? element.getBoundingClientRect() : {
    height: 0,
    left: 0,
    top: 0,
    width: 0
  };
  var contentHeight = element ? element.firstChild.offsetHeight + TOOLTIP_SPACING : 0;
  var startingSpotTop = element ? rect.top + rect.height / 2 : undefined;
  var startingSpotLeft = element ? rect.left : undefined;
  var top = at[1] || startingSpotTop;
  top = (isAbove ? rect.top - contentHeight : top) || undefined;
  top = (isBelow ? rect.bottom + TOOLTIP_SPACING : top) || undefined;
  var left = at[0] || startingSpotLeft;
  left = (center ? left + rect.width / 2 : left) || undefined;
  var style = usePosition ? {
    top: top,
    left: left,
    bottom: 'unset'
  } : {};
  var transform = adjustment ? {
    transform: "translateX(".concat(adjustment, "px)")
  } : {};
  return _objectSpread(_objectSpread({}, style), transform);
}